<template>
  <b-form-group
    label="Raporlarda Gösterme"
    label-for="report_hidden"
  >
    <b-form-checkbox
      id="report_hidden"
      v-model="dataItem.report_hidden"
      value="1"
      switch
    >
      {{ dataItem.report_hidden === '1'? 'Raporda Gösterilmez' : 'Raporda Görünür' }}
    </b-form-checkbox>
  </b-form-group>
</template>
<script>
import { BFormGroup, BFormCheckbox } from 'bootstrap-vue'

export default {
  name: 'ReportHidden',
  components: {
    BFormGroup, BFormCheckbox,
  },
  computed: {
    dataItem() {
      return this.$store.getters['donationGroups/dataItem']
    },
  },
}
</script>
